"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chunk = chunk;
exports.equalizeArrays = equalizeArrays;
exports.arrayCompare = arrayCompare;
exports.doesMatchChunk = doesMatchChunk;
exports.default = isGranted;
exports.GLOB_HIT = exports.MISS = exports.HIT = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _lodash = _interopRequireDefault(require("lodash"));

/**
 * splits a string on : character
 * @param {*} rule
 */
function chunk(rule) {
  return rule.split(':');
}
/**
 * given two arrays, pads the shorter one with empty spaces until they have equal length
 * @param {*} a
 * @param {*} b
 */

function equalizeArrays() {
  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var aLen = a.length;
  var bLen = b.length;
  var masterLen = _lodash.default.max([aLen, bLen]) || 0;
  var aArray = _lodash.default.fill(Array(masterLen), '');
  var bArray = _lodash.default.fill(Array(masterLen), '');
  for (var i = 0; i < masterLen; i += 1) {
    aArray[i] = a[i] || '';
    bArray[i] = b[i] || '';
  }
  return [aArray, bArray];
}
var HIT = 'HIT';
exports.HIT = HIT;
var MISS = 'MISS';
exports.MISS = MISS;
var GLOB_HIT = 'GLOB_HIT';
/**
 * given two arrays, for each value in aArray, compare with the value of the same index in bArray
 * if any of the pairs do not match, we return false, else true (wildcard on either side is a match)
 * (we use this to compare an exploded ("chunked") rule to an array of conditions, so that we
 * can determine if the rule is passed)
 * @param {*} aArray
 * @param {*} bArray
 * @param {*} invariant
 */

exports.GLOB_HIT = GLOB_HIT;
function arrayCompare(aArray, bArray, invariant) {
  // pad shorter array so that they are the same length
  var _equalizeArrays = equalizeArrays(aArray, bArray),
    _equalizeArrays2 = (0, _slicedToArray2.default)(_equalizeArrays, 2),
    a = _equalizeArrays2[0],
    b = _equalizeArrays2[1]; // use reduce to iterate through each value in the aArray, and compare it to the same index in the
  // bArray

  var result = _lodash.default.reduce(a, function (prevValue, aChunk, index) {
    var bChunk = b[index];
    switch (invariant(aChunk, bChunk)) {
      case HIT:
        if (prevValue === MISS) {
          return MISS;
        }
        if (prevValue === HIT) {
          return HIT;
        }
        if (prevValue === GLOB_HIT) {
          return GLOB_HIT;
        }
        break;
      case GLOB_HIT:
        if (prevValue === MISS) {
          return MISS;
        }
        if (prevValue === HIT) {
          return GLOB_HIT;
        }
        if (prevValue === GLOB_HIT) {
          return GLOB_HIT;
        }
        break;
      case MISS:
        if (prevValue === GLOB_HIT) {
          return GLOB_HIT;
        }
        if (prevValue === HIT) {
          return MISS;
        }
        if (prevValue === MISS) {
          return MISS;
        }
        break;
      default:
        return prevValue;
    }
    return prevValue;
  }, HIT); // if HIT or GLOB_HIT, return true

  if (result === HIT || result === GLOB_HIT) {
    return true;
  } // else return false

  return false;
}
/**
 * compare two strings, a match is 'HIT, a match via wildcard 'GLOB_HIT', and not a match 'MISS'
 * @param {*} subject
 * @param {*} test
 */

function doesMatchChunk(subject, test) {
  if (subject === test) {
    return HIT;
  }
  if (subject === '*') {
    return GLOB_HIT;
  }
  if (test === '*') {
    return GLOB_HIT;
  }
  return MISS;
}
/**
 * given a user permission array (e.g. ['sc', 'control-center', '*']), iterate through each required
 * permission trying to find a match
 *
 * @param {*} rule
 * @param {*} conditions
 * @returns true if a match is found, else false
 */

function compareAllConditions(userPermissionAsArray, requiredPermissions) {
  for (var i = 0; i < requiredPermissions.length; i += 1) {
    if (arrayCompare(userPermissionAsArray, chunk(requiredPermissions[i]), doesMatchChunk)) {
      return true;
    }
  }
  return false;
}
/**
 * @param userPermissions an array of user permission strings, e.g. `sc:control-center:*`
 * @returns true if the user is granted ANY of the required permissions, else false
 */

function isGranted(userPermissions, requiredPermissions) {
  return _lodash.default.chain(userPermissions) // pass rules to chunk, which splits on `:`, giving us an array of the permission parts, e.g
  // ['sc', 'control-center', '*']
  .map(function (userPermission) {
    return chunk(userPermission);
  }) // for each user permission, compare it to all of the requiredPermissions to see if user has access
  .reduce(function (acc, userPermissionAsArray) {
    return acc || compareAllConditions(userPermissionAsArray, _lodash.default.isString(requiredPermissions) ? [requiredPermissions] : requiredPermissions);
  }, false).value();
}